export const error = (msg) => {
    throw new Error(msg);
};
//# sourceMappingURL=errors.js.map